import { CiiContributionValueData, CiiContributionData } from "./data";

function _ciiContributionValueDataFromJson(json) {
    return new CiiContributionValueData(
        json['start_time'],
        json['display_title'],
        json['editable'],
        json['ytd'],
        json['rolling_12_m'],
        json['unit'],
        json['input']
    )
}

function ciiContributionDataFromJson(json) {
    return new CiiContributionData(
        _ciiContributionValueDataFromJson(json['distance']),
        _ciiContributionValueDataFromJson(json['avg_laden_speed']),
        _ciiContributionValueDataFromJson(json['avg_ballast_speed']),
        _ciiContributionValueDataFromJson(json['avg_laden_me_foc']),
        _ciiContributionValueDataFromJson(json['avg_ballast_me_foc']),
        _ciiContributionValueDataFromJson(json['excess_foc_due_to_weather']),
        _ciiContributionValueDataFromJson(json['avg_fouling']),
        _ciiContributionValueDataFromJson(json['laden_percentage_time']),
        _ciiContributionValueDataFromJson(json['ballast_percentage_time']),
        _ciiContributionValueDataFromJson(json['idle_percentage_time']),
        _ciiContributionValueDataFromJson(json['percentage_aux_co2_contribution']),
        _ciiContributionValueDataFromJson(json['cii'])
    )
}

export { ciiContributionDataFromJson };
